import React from "react";
import type {VoidFunctionComponent} from "react";
import {CardIconType} from "../../../models/view/common/ICard";
import {FontIcon} from "../../common/FontIcon";

export interface ICardIconProps {
  icon?: CardIconType
}

export const CardIcon: VoidFunctionComponent<ICardIconProps> = ({icon}) => {
  switch (icon ?? '') {
    case "video":
      return <FontIcon icon={"icon-video-tutorial-solid"} ariaLabel={'Includes video'} />;
    case "none":
      // fall-through
    default:
      return null;
  }
}

